import type { ButtonFormField } from '@sitecore-jss/sitecore-jss-forms';
import type { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { type FC, type MouseEventHandler, useEffect, useState } from 'react';

import Button from '../../../helpers/Button/Button';
import { useFormSubmitContext } from '../Context/FormSubmitContext';

/** Screen reader messages that alternate while form submission is in progress. */
const SUBMIT_LOADING_MESSAGES = ['Submitting your form...', 'Please wait...'];

/**
 * Overrides the built-in Sitecore Forms submit button.
 * @see [Original Button Implementation](https://github.com/Sitecore/jss/blob/dev/packages/sitecore-jss-react-forms/src/components/field-templates/button.tsx)
 *
 * @param props - Submit button properties.
 * @returns A submit button.
 */
export const SubmitButton: FC<FieldProps<ButtonFormField>> = (props) => {
  const { field, onButtonClick } = props;

  const { submitting } = useFormSubmitContext();
  const [clicked, setClicked] = useState(false);

  const loading = clicked && submitting;

  useEffect(() => {
    if (!submitting) {
      setClicked(false);
    }
  }, [submitting]);

  const handleClick: MouseEventHandler<HTMLButtonElement> = () => {
    setClicked(true);
    onButtonClick(field.buttonField?.name);
  };

  return (
    <Button
      className={field.model?.cssClass}
      id={field.buttonField?.id}
      loading={loading}
      loadingMessages={SUBMIT_LOADING_MESSAGES}
      name={field.buttonField?.name}
      onClick={handleClick}
      type="submit"
    >
      {field.model?.title}
    </Button>
  );
};

export default SubmitButton;
